import { render, staticRenderFns } from "./legals.vue?vue&type=template&id=e5cf289e&scoped=true&"
import script from "./legals.vue?vue&type=script&lang=js&"
export * from "./legals.vue?vue&type=script&lang=js&"
import style0 from "./legals.vue?vue&type=style&index=0&id=e5cf289e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cf289e",
  null
  
)

export default component.exports